<template>
  <b-row>
    <b-row class="list bkg">
      <b-form-input
      type="text"
      id="text-search"
      size="sm"
      v-model="search"
      placeholder="Busca..."
      v-on:keyup="onSearch"
      ></b-form-input>

      <h4>{{ titulo }}</h4>

      <b-row class="span" v-if="allPostagens < 1">
        <span>Não há nenhuma tradução para mostrar no momento...</span>
      </b-row>
      
      
      <b-card-group deck>
        <b-card
          v-for="postagem in result || allPostagens"
          :key="postagem.id"
          :header="postagem.title"
          style="min-width: 16rem; max-width: 21rem"
          header-bg-variant="dark"
          header-text-variant="white"
          align="center"
          class="unitCard"
        >
          <img width="300px" :src="postagem.img"/>

          <b-card-text><strong>Equipe: </strong>{{ postagem.equipe }}</b-card-text>
        
          <router-link
            tag="p"
            :to="{ name: 'postagemDetail', params: { id: postagem.id, postagem: postagem } }"
          >
            <b-button
            class="btn"
            block
            variant="primary"
            >Créditos e Download
          </b-button>

          </router-link>

          
          <b-button
            class="btn"
            @click="deletePostagem(postagem.id)"
            block
            variant="danger"
            >Excluir
          </b-button>

        </b-card>
      </b-card-group>
    </b-row>

    <b-row class="addPostagem">
      <AdicionarPostagem />
    </b-row>

  </b-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AdicionarPostagem from "./AdicionarPostagem";

export default {
  name: "ListaDePostagens",
  computed: {
    ...mapGetters(["allPostagens"]),
  },
  methods: {
    ...mapActions(["getPostagens", "deletePostagem"]),
    onSearch(){
      this.result = this.allPostagens.filter(x => x.title.toLowerCase().includes(this.search.toLowerCase()))
    }
  },
  components: {
    AdicionarPostagem,
  },
  created() {
    this.getPostagens();
  },
  data() {
    return {
      titulo: "Títulos encontrados:",
      search: "",
      result: null,
    };
  },
};
</script>

<style scoped>
.bkg{
  background-color: white;
  padding: 15px;
  min-height: 600px;
}
.card {
  margin: 15px;
}

.list {
  margin: 20px;
  width: 100%;
  display: block;
}

.block {
  display: block;
}

.unitCard:hover{
  border: rgb(59, 59, 59) 2px solid;
}

.addPostagem{
  padding: 20px;
}

input{
  margin-bottom: 30px;
}

.span{
  justify-content: center;
  padding: 20%;
}
</style>